/* eslint-disable import/extensions */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react-hooks/exhaustive-deps */
import {
    useState, useEffect, useMemo, createRef, useRef, useCallback, RefObject,
} from 'react';
import {
    useParams,
    useHistory,
    generatePath,
    useLocation,
    Redirect,
} from 'react-router-dom';
import { useIntl, FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { Helmet } from 'react-helmet';
import Container from '@ui/Container';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Chip from '@ui/Chip';
import LinearProgress from '@material-ui/core/LinearProgress';
import Fade from '@material-ui/core/Fade';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@ui/Typography';
import styled from '@ui/styles/styled';
import { azurColor } from '@ui/styles/colors';
import { ShapeId } from '@core/constants/Shape';
import FormGroupId from '@core/constants/FormGroupId';
import formGroups, { formGroupsFormGroups } from '@core/constants/FormGroups';
import projects from '@furnish-hx/constants/Projects';
import Routes, { RouteKey } from '@core/constants/Route';
import { lilmUrl, lilmArtisanUrl, termsAndConditionsUrl } from '@core/config/Url';
import { IArtisanPublicData } from '@core/interfaces/IArtisan';
import { PublishedFormIdUnion, FormIdUnion } from '@furnish-hx/constants/FormId';
import Spinner from '@ui/Spinner';
import Card from '@ui/Card';
import RenderDelayer from '@ui/RenderDelayer';
import { PublishedProjectId } from '@furnish-hx/constants/ProjectId';
import IFields from '@core/interfaces/IFields';
import {
    IForm,
    IForms,
    IFormKey,
    IFormFieldKey,
    IFormField,
} from '../../../../interfaces/Form';
import FormFieldRecap from '../../../components/FormFieldRecap';
import LogoDark from '../../../../assets/images/logo-lilm-dark.png';
import {
    formComposerChipStyle,
    stepperStyle,
    formFieldsWrapperStyle,
    formFieldsScrollWrapperStyle,
    stepButtonStyle,
    chipsSelectWrapperStyle,
    linearProgressStyle,
    buttonPrevStyle,
    buttonNextStyle,
    buttonPrevNextDisabledStyle,
    sideStepperStyle,
    sideStepperWrapperStyle,
    topStepperWrapperStyle,
    sideStepperLogoStyle,
    sideStepperCatchStyle,
    getSideStepperNoticeStyle,
    sideStepperMiniLogoStyle,
    sentenceWrapperStyle,
    sentenceStyle,
} from './styles';

import { getMergedStaticFormWidthFieldsValues, removeFormFields } from '../../../../transformers/Form';
import firebaseService from '../../../../services/Firebase';
import FormSubmitter from '../../../components/FormSubmitter';
import ChatQuestion from '../../ChatQuestion';
import ChatAnswer from '../../ChatAnswer';
import BoxComposition from '../../../components/BoxComposition';
import { makeHandleScrollToAnchorTop, makeHandleScrollToTop } from '../../../effects/scroll';
import { IStep, ExtraStep } from '../../../../interfaces/IStep';
import { FromId } from '../../../../constants/Analytics';
import getAvailableForms from '../utils';
import { formsWithDefault } from '../../../../constants/Form';
import FormComposerComponentChat from './types';
import config from './config';
import seoDefaultImageUrl from '../../../../constants/seo';

const SideStepperWrapper = styled('div')(sideStepperWrapperStyle);
const SideStepper = styled(Stepper)(sideStepperStyle);
const SideStepperLogo = styled('img')(sideStepperLogoStyle);
const SideStepperMiniLogo = styled('img')(sideStepperMiniLogoStyle);
const SideStepperCatchSentence = styled(Typography)(sideStepperCatchStyle);
const StyledSideStepperNotice = styled(Typography)(getSideStepperNoticeStyle);
const TopStepperWrapper = styled(Container)(topStepperWrapperStyle);
const FormFieldsScrollWrapperStyle = styled('div')(formFieldsScrollWrapperStyle);
const WrapperSentenceStyle = styled('div')(sentenceWrapperStyle);

const FormComposerChat: FormComposerComponentChat = ({
    isExternal,
    shouldHideIsPrivateQuestion,
    showFields,
    removeFields = [IFormFieldKey.PortfolioData, IFormFieldKey.Comment],
}) => {
    const intl = useIntl();
    const history = useHistory();
    const { search } = useLocation();
    const {
        artisanSlug,
        formId,
        stepId,
        formGroupId,
        tmpSubmissionId,
        artisanProjectId,
    } = useParams<{
        artisanSlug?: string,
        formId?: PublishedFormIdUnion,
        stepId?: string,
        formGroupId?: string,
        tmpSubmissionId?: string,
        artisanProjectId?: string,
    }>();
    const [artisanForms, setArtisanForms] = useState<IForms | undefined>(undefined);
    const [artisanProjectForm, setArtisanProjectForm] = useState<IFields | undefined>(undefined);

    const { nosubmit } = useMemo(() => Object.fromEntries(new URLSearchParams(window.location.search).entries()), []);

    const availableForms = useMemo<IForms>(() => (!formGroupId && artisanForms) || getAvailableForms(formsWithDefault, formGroups, formId as PublishedFormIdUnion, formGroupId as FormGroupId), [formGroupId, formId, formGroups, artisanForms]);

    // @ts-ignore
    const form: IForm = useMemo<IForm | undefined>(() => {
        const selectedBaseForm = !stepId && availableForms.length > 1 && formGroupId ? undefined : availableForms.find((availableForm) => availableForm[IFormKey.FormId] === formId);

        if (!selectedBaseForm) return undefined;
        const unneededFields = [...removeFields];

        if (shouldHideIsPrivateQuestion && selectedBaseForm.fields?.additionalData?.isPrivate) {
            delete selectedBaseForm.fields.additionalData.isPrivate;
        }

        if (artisanProjectId && selectedBaseForm.fields?.additionalData?.comment) {
            unneededFields.push(IFormFieldKey.Description);
            delete selectedBaseForm.fields.additionalData.comment;
        }

        if (nosubmit) {
            unneededFields.push(IFormFieldKey.Contact);
        }

        return removeFormFields(selectedBaseForm, unneededFields);
    }, [stepId, availableForms, formGroupId, removeFields, shouldHideIsPrivateQuestion, artisanProjectId, nosubmit, formId]);

    // The state of the form
    const [formState, setFormState] = useState<IForm>(form);
    const [formCompletion, setFormCompletion] = useState<number>(0);
    const [currentFormFieldKey, setCurrentFormFieldKey] = useState<IStep>(stepId as IStep || ExtraStep.Intro);
    const [nextFormFieldKey, setNextFormFieldKey] = useState<IStep>(ExtraStep.Intro);
    const [hasConfirmedIntro, setHasConfirmedIntro] = useState<boolean>(!!tmpSubmissionId || !!formState);
    const [artisanPublicData, setArtisanPublicData] = useState<IArtisanPublicData | undefined>(undefined);

    const formStateFieldsEntries = useMemo(() => (formState ? Object
        .entries(formState.fields)
        .sort((a, b) => formState[IFormKey.FieldsOrder].indexOf(a[0] as IFormFieldKey) - formState[IFormKey.FieldsOrder].indexOf(b[0] as IFormFieldKey)) : []),
    [formState]);

    const currentFormFieldIndex = useMemo(() => (
        currentFormFieldKey !== ExtraStep.Intro && currentFormFieldKey
            ? formStateFieldsEntries.findIndex((entry) => entry[0] === currentFormFieldKey) + 1 : 0),
    [formState, currentFormFieldKey]);

    const nextFormFieldIndex = useMemo(() => (
        nextFormFieldKey !== ExtraStep.Intro && currentFormFieldKey
            ? formStateFieldsEntries.findIndex((entry) => entry[0] === nextFormFieldKey) + 1 : 0),
    [formState, nextFormFieldKey]);

    const seoTitle = useMemo(() => {
        if (form) return `${intl.formatMessage({ id: `forms.${form[IFormKey.FormId]}.name` })} | LILM`;
        if (formGroupId) {
            return `${intl.formatMessage({
                id: intl.messages[`formGroups.${formGroupId}`]
                    ? `formGroups.${formGroupId}`
                    : `projects.${formGroupId}`,
            })} | LILM`;
        }

        return intl.formatMessage({ id: 'seoTitleDefault' });
    }, [intl, form, formGroupId]);

    const seoDescription = useMemo(() => {
        if (form) return `${intl.formatMessage({ id: `components.FormComposer.sideStepperCatchForm.${form[IFormKey.FormId]}` })} | LILM`;

        return `${intl.formatMessage({ id: `components.FormComposer.sideStepperCatchFormGroup.${formGroupId}` })}  | LILM`;
    }, [intl, form, formGroupId]);

    const seoImageUrl = useMemo(() => {
        if (form && form.thumbnailURL) return form.thumbnailURL;
        if (availableForms.length > 0 && availableForms[0].thumbnailURL) return availableForms[0].thumbnailURL;

        return seoDefaultImageUrl;
    }, [intl, form, availableForms]);

    // Refs
    const formFieldsWrapperReference = useRef<HTMLDivElement>(null);
    const formFieldsStepsWrapperReference = useRef<HTMLDivElement>(null);
    const formFieldsStepsReferences = formStateFieldsEntries.reduce((acc, [formFieldKey]) => ({
        ...acc, [formFieldKey as IFormFieldKey]: createRef<HTMLDivElement>(),
    }), { [ExtraStep.Intro]: createRef<HTMLDivElement>() } as {[key in IStep]: RefObject<HTMLDivElement>});

    // Handlers
    const handleScrollToAnchor = useCallback(makeHandleScrollToAnchorTop(formFieldsWrapperReference), [formFieldsWrapperReference]);
    const handleScrollTop = useCallback(makeHandleScrollToTop(formFieldsWrapperReference), [formFieldsWrapperReference]);

    // Effects
    useEffect(() => { setFormState((previousFormState) => (previousFormState?.formId !== form?.formId ? form : previousFormState)); }, [form]);

    useEffect(() => {
        if (stepId !== currentFormFieldKey) {
            if (stepId) {
                setCurrentFormFieldKey(stepId as IStep);
            } else {
                setCurrentFormFieldKey(ExtraStep.Intro);
            }
        }
    }, [stepId]);

    useEffect(() => {
        if (artisanSlug && artisanSlug !== artisanPublicData?.slug) {
            (async () => {
                const artisanPublic = await (await firebaseService.getInstance()).getArtisanPublicData(artisanSlug);

                if (artisanPublic) {
                    window.artisanPublicData = artisanPublic;
                    setArtisanPublicData(artisanPublic);
                }
            })();
        }
    }, [artisanSlug, artisanPublicData, setArtisanPublicData]);

    useEffect(() => {
        const shouldLoadArtisanForms = artisanPublicData && !formId && !formGroupId && !artisanForms;

        if (shouldLoadArtisanForms && isExternal && artisanPublicData?.appFormIds && artisanPublicData.appFormIds.length > 0) {
            setArtisanForms(artisanPublicData.appFormIds
                .map((appFormId) => formsWithDefault.find((filteredForm) => filteredForm.formId === appFormId))
                .filter((filteredForm) => filteredForm !== undefined) as IForm[]);
        } else if (shouldLoadArtisanForms && artisanPublicData?.projectIds && artisanPublicData.projectIds.length > 0) {
            const artisanProjectsForms = artisanPublicData.projectIds.reduce((acc, projectId) => [
                ...acc,
                ...(projects[projectId as PublishedProjectId] && projects[projectId as PublishedProjectId]),
            ], [] as PublishedFormIdUnion[])
                .map((filteredFormId) => formsWithDefault.find((filteredForm) => filteredForm.formId === filteredFormId))
                .filter((filteredForm) => filteredForm !== undefined);
            // eslint-disable-next-line unicorn/prefer-spread
            setArtisanForms(Array.from(new Set(artisanProjectsForms)) as IForm[]);
        }
    }, [artisanPublicData, artisanForms, setArtisanForms, formGroupId, formId, isExternal]);

    useEffect(() => {
        (async () => {
            if (tmpSubmissionId) {
                const tmpSubmission = await (await firebaseService.getInstance()).getSubmission(tmpSubmissionId, true);
                if (tmpSubmission) {
                    setFormState(
                        removeFormFields(
                            getMergedStaticFormWidthFieldsValues(form, tmpSubmission.data.fields),
                            removeFields,
                        ),
                    );
                }
            }
        })();
    }, [tmpSubmissionId, removeFields]);

    useEffect(() => {
        (async () => {
            if (artisanProjectId && !tmpSubmissionId) {
                const projectData = await (await firebaseService.getInstance()).getArtisanProject(artisanProjectId);
                if (projectData) {
                    const price = projectData.data.fields.portfolioData?.price;
                    const projectDataForm = removeFormFields(
                        getMergedStaticFormWidthFieldsValues(form, projectData.data.fields),
                        removeFields,
                    ) as IForm;
                    setArtisanProjectForm(projectData.data.fields);
                    if (artisanProjectForm) {
                        // @ts-ignore
                        delete artisanProjectForm.portfolioData?.description;
                    }
                    if (projectDataForm.fields.additionalData.budget && price) {
                        const { budget } = projectDataForm.fields.additionalData;
                        budget.defaultValue = price;
                        budget.range.min = price / 2;
                        budget.range.max = price * 2;
                    }
                    setFormState(projectDataForm);
                }
            }
        })();
    }, [artisanProjectId, removeFields]);

    const filteredFormStateFieldsEntries = useMemo(() => {
        const validFormStateFieldsEntries = showFields ? formStateFieldsEntries.filter(([id, _]) => showFields.includes(id as IFormFieldKey)) : formStateFieldsEntries;

        return validFormStateFieldsEntries;
    }, [formStateFieldsEntries, showFields]);

    useEffect(() => {
        if (!stepId && formGroupId && availableForms.length === 1) {
            const defaultForm = removeFormFields(availableForms[0], removeFields);
            if (artisanSlug && isExternal) {
                history.replace(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormGroupStep], {
                    artisanSlug,
                    formId : defaultForm[IFormKey.FormId],
                    stepId : defaultForm[IFormKey.FieldsOrder][0],
                }) + search);
            } else if (artisanSlug) {
                history.replace(generatePath(Routes[RouteKey.ArtisanFormGroupStep], {
                    artisanSlug,
                    formGroupId,
                    formId : defaultForm[IFormKey.FormId],
                    stepId : defaultForm[IFormKey.FieldsOrder][0],
                }) + search);
            } else {
                history.replace(generatePath(Routes[RouteKey.FormGroupStep], {
                    formGroupId,
                    formId : defaultForm[IFormKey.FormId],
                    stepId : defaultForm[IFormKey.FieldsOrder][0],
                }) + search);
            }

            setFormState(defaultForm);
            setHasConfirmedIntro(true);
        }
    }, [formGroupId, stepId, search, availableForms, setFormState, isExternal, artisanSlug, removeFields]);

    useEffect(() => {
        const nextStep = formState && formStateFieldsEntries.find(
            ([formFieldKey, formField]) => !config[(formFieldKey as IFormFieldKey)].fieldValidate(formField),
        );

        setFormCompletion(Math.ceil((formStateFieldsEntries.filter(
            ([formFieldKey, formField]) => config[(formFieldKey as IFormFieldKey)].fieldValidate(formField),
        ).length / formStateFieldsEntries.length) * 100));

        if (!hasConfirmedIntro) {
            setNextFormFieldKey(ExtraStep.Intro);
            setCurrentFormFieldKey(ExtraStep.Intro);
        } else if (nextStep) {
            setNextFormFieldKey(nextStep[0] as IStep);
            setCurrentFormFieldKey(nextStep[0] as IStep);
            if (formGroupId && artisanSlug && isExternal) {
                history.push(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormGroupStep], {
                    artisanSlug,
                    formGroupId,
                    formId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            } else if (formGroupId && artisanSlug && !isExternal) {
                history.push(generatePath(Routes[RouteKey.ArtisanFormGroupStep], {
                    artisanSlug,
                    formGroupId,
                    formId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            } else if (formGroupId && !artisanSlug && !isExternal) {
                history.push(generatePath(Routes[RouteKey.FormGroupStep], {
                    formGroupId,
                    formId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            } else if (!formGroupId && artisanSlug && isExternal) {
                history.push(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormStep], {
                    artisanSlug,
                    formId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            } else if (!formGroupId && artisanSlug && !isExternal) {
                history.push(generatePath(Routes[RouteKey.ArtisanFormStep], {
                    artisanSlug,
                    formId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            } else if (artisanProjectId) {
                history.push(generatePath(Routes[RouteKey.ArtisanProjectForm], {
                    formId,
                    artisanProjectId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            } else {
                history.push(generatePath(Routes[RouteKey.FormStep], {
                    formId,
                    stepId: nextStep[0] as IStep,
                }) + search);
            }
        }
    }, [formState, hasConfirmedIntro, formStateFieldsEntries, search, formGroupId, isExternal, artisanSlug]);

    useEffect(() => {
        // @ts-ignore
        const currentFormFieldStepReference = formFieldsStepsReferences[currentFormFieldKey as IFormFieldKey]?.current;

        if (formFieldsStepsWrapperReference?.current && currentFormFieldStepReference) {
            formFieldsStepsWrapperReference.current.scrollLeft
            = currentFormFieldStepReference.getBoundingClientRect().left
            - formFieldsStepsWrapperReference.current.getBoundingClientRect().left
            + formFieldsStepsWrapperReference.current.scrollLeft
            - (formFieldsStepsWrapperReference.current.clientWidth / 2)
            + (currentFormFieldStepReference.clientWidth / 2);
        }

        if (formFieldsStepsWrapperReference?.current && !currentFormFieldStepReference) {
            formFieldsStepsWrapperReference.current.scrollLeft
            = 9999999;
        }
    }, [currentFormFieldKey]);

    const handleCurrentFormFieldKeyUpdate = useCallback((formFieldKey: IStep, from: FromId, newFormId?: FormIdUnion) => async () => {
        setCurrentFormFieldKey(formFieldKey);
        if (formGroupId && artisanSlug && isExternal) {
            history.push(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormGroupStep], {
                artisanSlug,
                formGroupId,
                formId : newFormId || formId,
                stepId : formFieldKey,
            }) + search);
        } else if (formGroupId && artisanSlug && !isExternal) {
            history.push(generatePath(Routes[RouteKey.ArtisanFormGroupStep], {
                artisanSlug,
                formGroupId,
                formId : newFormId || formId,
                stepId : formFieldKey,
            }) + search);
        } else if (formGroupId && !artisanSlug && !isExternal) {
            history.push(generatePath(Routes[RouteKey.FormGroupStep], {
                formGroupId,
                formId : newFormId || formId,
                stepId : formFieldKey,
            }) + search);
        } else if (!formGroupId && artisanSlug && isExternal) {
            history.push(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormStep], {
                artisanSlug,
                formId : newFormId || formId,
                stepId : formFieldKey,
            }) + search);
        } else if (!formGroupId && artisanSlug && !isExternal) {
            history.push(generatePath(Routes[RouteKey.ArtisanFormStep], {
                artisanSlug,
                formId : newFormId || formId,
                stepId : formFieldKey,
            }) + search);
        } else if (artisanProjectId) {
            history.push(generatePath(Routes[RouteKey.ArtisanProjectForm], {
                formId : newFormId || formId,
                artisanProjectId,
                stepId : formFieldKey,
            }) + search);
        } else {
            history.push(generatePath(Routes[RouteKey.FormStep], {
                formId : newFormId || formId,
                stepId : formFieldKey,
            }) + search);
        }
        (await firebaseService.getInstance()).trackClick(formFieldKey, from);
    }, [setCurrentFormFieldKey, history, formId, search, formGroupId, isExternal, artisanSlug]);

    const handlePrev = useCallback(() => {
        const prev = currentFormFieldIndex === 1 ? ExtraStep.Intro : formState[IFormKey.FieldsOrder][currentFormFieldIndex - 2];
        handleCurrentFormFieldKeyUpdate(prev, FromId.NAV)();
    }, [currentFormFieldIndex, handleCurrentFormFieldKeyUpdate, formState]);

    const handleNext = useCallback(() => {
        const next = formState[IFormKey.FieldsOrder][currentFormFieldIndex];
        handleCurrentFormFieldKeyUpdate(next, FromId.NAV)();
    }, [currentFormFieldIndex, handleCurrentFormFieldKeyUpdate]);

    const handleFormFieldSubmission = useCallback((formKey: IFormFieldKey) => (formField: IFormField) => {
        setFormState((previousFormState) => ({ ...previousFormState, fields: { ...previousFormState.fields, [formKey]: formField } }));
    }, [setFormState]);

    const handleHasConfirmedIntroUpdate = useCallback((newFormId: FormIdUnion) => async () => {
        if (!stepId && formGroupId && artisanSlug && isExternal) {
            history.replace(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormGroupStep], {
                artisanSlug,
                formGroupId,
                formId : newFormId,
                stepId : ExtraStep.Intro,
            }) + search);
        } else if (!stepId && formGroupId && artisanSlug && !isExternal) {
            history.replace(generatePath(Routes[RouteKey.ArtisanFormGroupStep], {
                artisanSlug,
                formGroupId,
                formId : newFormId,
                stepId : ExtraStep.Intro,
            }) + search);
        } else if (!stepId && formGroupId && !artisanSlug && !isExternal) {
            history.replace(generatePath(Routes[RouteKey.FormGroupStep], {
                formGroupId,
                formId : newFormId,
                stepId : ExtraStep.Intro,
            }) + search);
        } else if (!stepId && !formGroupId && artisanSlug && isExternal) {
            history.replace(generatePath(Routes[RouteKey.ArtisanDedicatedAppFormStep], {
                artisanSlug,
                formId : newFormId,
                stepId : ExtraStep.Intro,
            }) + search);
        } else if (!stepId && !formGroupId && artisanSlug && !isExternal) {
            history.replace(generatePath(Routes[RouteKey.ArtisanFormStep], {
                artisanSlug,
                formId : newFormId,
                stepId : ExtraStep.Intro,
            }) + search);
        } else if (!stepId && !formGroupId && !artisanSlug && !isExternal) {
            history.replace(generatePath(Routes[RouteKey.FormStep], {
                formId : newFormId,
                stepId : ExtraStep.Intro,
            }) + search);
        } else if (artisanProjectId) {
            history.push(generatePath(Routes[RouteKey.ArtisanProjectForm], {
                formId : newFormId,
                artisanProjectId,
                stepId : ExtraStep.Intro,
            }) + search);
        }
        setHasConfirmedIntro(true);
        const formFirstStep = (availableForms.find((availableForm) => availableForm[IFormKey.FormId] === newFormId) as IForm)[IFormKey.FieldsOrder][0];
        handleCurrentFormFieldKeyUpdate(formFirstStep, FromId.STYLE, newFormId)();
    }, [setHasConfirmedIntro, history, search, formGroupId, handleNext, handleCurrentFormFieldKeyUpdate, isExternal]);

    const handleHasConfirmedIntroReset = useCallback(() => setHasConfirmedIntro(false), [setHasConfirmedIntro]);

    if (availableForms.length === 0 || (isExternal && artisanPublicData && (!artisanPublicData?.appFormIds || artisanPublicData.appFormIds.length === 0))) {
        return <Redirect to={Routes[RouteKey.Welcome]} />;
    }

    return (artisanSlug && !formId && !formGroupId && !artisanForms) || (artisanSlug && !artisanPublicData) ? (
        <Spinner />
    ) : (
        <>
            <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
                <meta property="og:image" content={seoImageUrl} />
                <meta property="og:title" content={seoTitle} />
                <meta property="og:description" content={seoDescription} />
                <meta name="twitter:title" content={seoTitle} />
                <meta name="twitter:description" content={seoDescription} />
                <meta name="robots" content="noindex" />
            </Helmet>

            <LinearProgress
                style={linearProgressStyle}
                variant="determinate"
                value={formCompletion}
                color="primary"
            />

            <SideStepperWrapper>
                {isExternal && artisanPublicData?.profileLogoUrl
                    ? <SideStepperLogo src={artisanPublicData.profileLogoUrl} alt="logo" />
                    : (
                        <a href={lilmUrl} target="_blank">
                            <SideStepperLogo src={LogoDark} alt="logo" />
                        </a>
                    ) }

                <SideStepperCatchSentence variant="h6">
                    <small>
                        {isExternal && artisanPublicData?.companyName
                            ? <FormattedMessage id="components.FormComposer.sideStepperCatchExternal" values={{ artisanName: artisanPublicData?.companyName }} />
                            : (
                                <FormattedMessage id={
                                    formGroupId && intl.messages[`components.FormComposer.sideStepperCatchFormGroup.${formGroupId}`] ? `components.FormComposer.sideStepperCatchFormGroup.${formGroupId}`
                                        : (formId && intl.messages[`components.FormComposer.sideStepperCatchForm.${formId}`] ? `components.FormComposer.sideStepperCatchForm.${formId}`
                                            : 'components.FormComposer.sideStepperCatchForm.undefined')
                                }
                                />
                            ) }
                    </small>
                </SideStepperCatchSentence>

                <SideStepper
                    activeStep={currentFormFieldIndex + (availableForms.length > 1 ? 0 : -1)}
                    orientation="vertical"
                >
                    {availableForms.length > 1 && (
                        <Fade in timeout={600} key={ExtraStep.Intro}>
                            <Step ref={formFieldsStepsReferences[ExtraStep.Intro]}>
                                <StepButton onClick={handleCurrentFormFieldKeyUpdate(ExtraStep.Intro, FromId.NAV)} completed={hasConfirmedIntro} disabled={!formId}>
                                    <StepLabel style={{ textAlign: 'left' as 'left' }}>
                                        <Typography variant="caption">
                                            <FormattedMessage id={`components.FormComposer.intro.labels.${formGroupsFormGroups[formGroupId as FormGroupId] ? formGroupId : undefined}`} />
                                        </Typography>
                                    </StepLabel>
                                </StepButton>
                            </Step>
                        </Fade>
                    )}

                    {filteredFormStateFieldsEntries.map(([formFieldKey, formField], index) => {
                        const isSubmitted = config[(formFieldKey as IFormFieldKey)].fieldValidate(formField);

                        return (
                            <Fade in timeout={600 + (index * 200)} key={formFieldKey}>
                                <Step ref={formFieldsStepsReferences[formFieldKey as IFormFieldKey]}>
                                    <StepButton
                                        onClick={handleCurrentFormFieldKeyUpdate(formFieldKey as IFormFieldKey, FromId.NAV)}
                                        completed={isSubmitted}
                                        disabled={!isSubmitted && formFieldKey !== nextFormFieldKey}
                                        style={{ ...(!isSubmitted && formFieldKey !== nextFormFieldKey && { opacity: 0.5 }) }}
                                    >
                                        <StepLabel>
                                            <Typography variant="caption">
                                                <FormattedMessage id={`fieldsChat.${formFieldKey}.label`} />
                                            </Typography>
                                        </StepLabel>
                                    </StepButton>
                                </Step>
                            </Fade>
                        );
                    })}
                </SideStepper>

                {isExternal && artisanPublicData?.profileLogoUrl && (
                    <a href={lilmUrl} target="_blank">
                        <SideStepperMiniLogo src={LogoDark} alt="logo LILM" />
                    </a>
                ) }

                <Typography variant="caption">
                    <a href={lilmArtisanUrl} target="_blank" style={{ color: azurColor }}>
                        <FormattedMessage id="artisanOnboardingLink" />
                    </a>
                </Typography>

                <StyledSideStepperNotice variant="caption">
                    <small>
                        <FormattedHTMLMessage id="sideStepperNotice" values={{ termsAndConditionsUrl }} />
                    </small>
                </StyledSideStepperNotice>
            </SideStepperWrapper>

            <TopStepperWrapper maxWidth="sm">
                <Button
                    onClick={handlePrev}
                    style={{ ...buttonPrevStyle, ...((availableForms.length > 1 ? currentFormFieldKey === ExtraStep.Intro : formStateFieldsEntries.findIndex(([key]) => key === currentFormFieldKey) === 0) && buttonPrevNextDisabledStyle) }}
                    disabled={availableForms.length > 1 ? currentFormFieldKey === ExtraStep.Intro : formStateFieldsEntries.findIndex(([key]) => key === currentFormFieldKey) === 0}
                >
                    <ChevronLeftIcon />
                </Button>

                <Button
                    onClick={handleNext}
                    style={{ ...buttonNextStyle, ...(currentFormFieldKey === nextFormFieldKey && buttonPrevNextDisabledStyle) }}
                    disabled={currentFormFieldKey === nextFormFieldKey}
                >
                    <ChevronRightIcon />
                </Button>

                <Stepper
                    alternativeLabel
                    nonLinear
                    activeStep={currentFormFieldIndex + (availableForms.length > 1 ? 0 : -1)}
                    style={stepperStyle}
                    ref={formFieldsStepsWrapperReference}
                    connector={undefined}
                >
                    {availableForms.length > 1 && (
                        // @ts-ignore
                        <Step ref={formFieldsStepsReferences.intro} style={stepButtonStyle} key={ExtraStep.Intro}>
                            <StepButton onClick={handleCurrentFormFieldKeyUpdate(ExtraStep.Intro, FromId.NAV)} completed={hasConfirmedIntro}>
                                <Chip
                                    style={formComposerChipStyle}
                                    size="small"
                                    label={intl.formatMessage({ id: `components.FormComposer.intro.labels.${formGroupsFormGroups[formGroupId as FormGroupId] ? formGroupId : undefined}` })}
                                />
                            </StepButton>
                        </Step>
                    )}

                    {filteredFormStateFieldsEntries.map(([formFieldKey, formField]) => {
                        const isSubmitted = config[(formFieldKey as IFormFieldKey)].fieldValidate(formField);

                        return (
                            <Step
                                // @ts-ignore
                                ref={formFieldsStepsReferences[formFieldKey as IFormFieldKey]}
                                style={stepButtonStyle}
                                key={formFieldKey}
                            >
                                <StepButton
                                    onClick={handleCurrentFormFieldKeyUpdate(formFieldKey as IFormFieldKey, FromId.NAV)}
                                    completed={isSubmitted}
                                    disabled={!isSubmitted && formFieldKey !== nextFormFieldKey}
                                >
                                    <Chip
                                        style={formComposerChipStyle}
                                        size="small"
                                        label={intl.formatMessage({ id: `fieldsChat.${formFieldKey}.label` })}
                                    />
                                </StepButton>
                            </Step>
                        );
                    })}
                </Stepper>
            </TopStepperWrapper>

            <div style={formFieldsWrapperStyle} ref={formFieldsWrapperReference}>
                <FormFieldsScrollWrapperStyle>
                    <Container maxWidth="sm">
                        {(availableForms.length > 1 ? currentFormFieldKey === ExtraStep.Intro : formStateFieldsEntries.findIndex(([key]) => key === currentFormFieldKey) === 0) && (
                            <>
                                {artisanProjectId && artisanProjectForm && (
                                    <Card elevation={0} style={{ padding: 10, margin: 10 }}>
                                        <WrapperSentenceStyle>
                                            <Typography style={sentenceStyle} color="primary">
                                                <FormattedMessage id="headerSentenceInRecapFormFlow" values={{ projectTitle: artisanProjectForm.portfolioData?.title }} />
                                            </Typography>
                                        </WrapperSentenceStyle>
                                        <FormFieldRecap
                                            fields={artisanProjectForm}
                                            shouldHideTitle
                                            shouldHideSubTitle
                                        />
                                    </Card>
                                )}

                                {!artisanProjectId && (
                                    <>
                                        <ChatQuestion isExternal={isExternal} shouldAnimateOnMount={!hasConfirmedIntro}>
                                            <FormattedMessage id={isExternal
                                                ? 'components.FormComposer.intro.introArtisan'
                                                : 'components.FormComposer.intro.intro'}
                                            />
                                        </ChatQuestion>

                                        <ChatQuestion isExternal={isExternal} shouldAnimateOnMount={!hasConfirmedIntro} animationDelay={1500}>
                                            <FormattedMessage
                                                id={((!isExternal && !artisanPublicData) && 'components.FormComposer.intro.introBis')
                                        || ((!isExternal && artisanPublicData) && 'components.FormComposer.intro.introBisArtisan')
                                        || ((isExternal && artisanPublicData?.firstName) && 'components.FormComposer.intro.introBisArtisanAppNamed')
                                        || 'components.FormComposer.intro.introBisArtisanApp'}
                                                {...(artisanPublicData && {
                                                    values: { artisanName: artisanPublicData.firstName, companyName: artisanPublicData.companyName },
                                                })}
                                            />
                                        </ChatQuestion>
                                    </>
                                )}
                            </>
                        )}
                        <>
                            {/* // @ts-ignore */}
                            {currentFormFieldKey === ExtraStep.Intro && (
                                <>
                                    <ChatQuestion isExternal={isExternal} shouldAnimateOnMount={!hasConfirmedIntro} animationDelay={3000}>
                                        <FormattedMessage id={`components.FormComposer.intro.titles.${formGroupsFormGroups[formGroupId as FormGroupId] ? formGroupId : undefined}`} />
                                    </ChatQuestion>

                                    {!hasConfirmedIntro ? (
                                        <>
                                            <div style={chipsSelectWrapperStyle}>
                                                {availableForms.filter(({ thumbnailURL }) => !!thumbnailURL).sort((a, b) => (
                                                    intl.formatMessage({ id: `forms.${a.formId}.name` }).localeCompare(intl.formatMessage({ id: `forms.${b.formId}.name` }))
                                                )).map((availableForm, index, arr) => (
                                                    <BoxComposition
                                                        key={availableForm[IFormKey.FormId]}
                                                        labelId={`forms.${availableForm[IFormKey.FormId]}.name`}
                                                        subtitleLabelId={`forms.${availableForm[IFormKey.FormId]}.label`}
                                                        source={availableForm.thumbnailURL}
                                                        onClick={handleHasConfirmedIntroUpdate(availableForm[IFormKey.FormId])}
                                                        col2={arr.length > 3 && formId !== availableForm[IFormKey.FormId]}
                                                        delay={!hasConfirmedIntro && !stepId && !formState ? 4500 : 1}
                                                        index={index}
                                                        imagesURLs={availableForm.imagesURLs}
                                                        description={
                                                            intl.messages[`forms.${availableForm[IFormKey.FormId]}.description.title`]
                                                        && intl.messages[`forms.${availableForm[IFormKey.FormId]}.description.content`]
                                                                ? {
                                                                    titleLabelId   : `forms.${availableForm[IFormKey.FormId]}.description.title`,
                                                                    contentLabelId : `forms.${availableForm[IFormKey.FormId]}.description.content`,
                                                                }
                                                                : undefined
                                                        }
                                                    />
                                                ))}
                                            </div>

                                            <div style={chipsSelectWrapperStyle}>
                                                {availableForms.filter(({ thumbnailURL }) => !thumbnailURL).sort((a, b) => (
                                                    intl.formatMessage({ id: `forms.${a.formId}.name` }).localeCompare(intl.formatMessage({ id: `forms.${b.formId}.name` }))
                                                )).map((availableForm, index, arr) => (
                                                    <BoxComposition
                                                        key={availableForm[IFormKey.FormId]}
                                                        labelId={`forms.${availableForm[IFormKey.FormId]}.name`}
                                                        subtitleLabelId={`forms.${availableForm[IFormKey.FormId]}.label`}
                                                        source={availableForm.thumbnailURL}
                                                        onClick={handleHasConfirmedIntroUpdate(availableForm[IFormKey.FormId])}
                                                        col2={arr.length > 3 && formId !== availableForm[IFormKey.FormId]}
                                                        delay={!hasConfirmedIntro && !stepId && !formState ? 4500 : 1}
                                                        index={index}
                                                        imagesURLs={availableForm.imagesURLs}
                                                        description={
                                                            intl.messages[`forms.${availableForm[IFormKey.FormId]}.description.title`]
                                                        && intl.messages[`forms.${availableForm[IFormKey.FormId]}.description.content`]
                                                                ? {
                                                                    titleLabelId   : `forms.${availableForm[IFormKey.FormId]}.description.title`,
                                                                    contentLabelId : `forms.${availableForm[IFormKey.FormId]}.description.content`,
                                                                }
                                                                : undefined
                                                        }
                                                    />
                                                ))}
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            <ChatAnswer
                                                onDelete={handleHasConfirmedIntroReset}
                                                contentSource={formState[IFormKey.ThumbnailURL]}
                                            >
                                                {intl.messages[`components.FormComposer.intro.answers.${formId}`] ? (
                                                    <FormattedMessage id={`components.FormComposer.intro.answers.${formId}`} />
                                                ) : (
                                                    <FormattedMessage
                                                        id="components.FormComposer.intro.answers.default"
                                                        values={{ formName: intl.formatMessage({ id: `forms.${formId}.name` }).toLowerCase() }}
                                                    />
                                                )}
                                            </ChatAnswer>
                                        </>
                                    )}
                                </>
                            )}

                            {formStateFieldsEntries.map(([formFieldKey, formField], index, entries) => {
                                const previousFormFieldValueAnswer = Array.isArray(entries[index - 1])
                                    && ((
                                        !!entries[index - 1][1]?.value && intl.messages[`formValuesAnswers.${entries[index - 1][1].value}`]
                                    ) || (
                                        !!entries[index - 1][1]?.material?.value && intl.messages[`formValuesAnswers.${entries[index - 1][1]?.material.value}`]
                                    ));
                                const validate = formFieldKey
                                    ? config[formFieldKey as IFormFieldKey].fieldValidate
                                    : undefined;
                                const Component = formFieldKey
                                    ? config[formFieldKey as IFormFieldKey].fieldComponent
                                    : undefined;
                                const isSubmitted = !!validate && validate(formField);

                                return Component && validate && currentFormFieldKey === formFieldKey && (index < nextFormFieldIndex || isSubmitted) ? (
                                    <Fade in timeout={1000} key={formFieldKey}>
                                        <div>
                                            {previousFormFieldValueAnswer && (
                                                <ChatQuestion isExternal={isExternal} shouldAnimateOnMount={!isSubmitted}>
                                                    {previousFormFieldValueAnswer}
                                                </ChatQuestion>
                                            )}

                                            <RenderDelayer delay={!isSubmitted && previousFormFieldValueAnswer ? 1500 : 0}>
                                                <Component
                                                    labelsRootPath="fieldsChat"
                                                    // @ts-ignore
                                                    formFieldKey={formFieldKey as IFormFieldKey}
                                                    formField={formField}
                                                    submit={handleFormFieldSubmission(formFieldKey as IFormFieldKey)}
                                                    onEdit={handleCurrentFormFieldKeyUpdate(formFieldKey as IFormFieldKey, FromId.EDIT_COMPONENT)}
                                                    onMount={handleScrollTop}
                                                    onSelect={handleScrollToAnchor}
                                                    // @ts-ignore
                                                    getExclusions={config[formFieldKey as IFormFieldKey]?.fieldExclusionsGetter}
                                                    isSubmitted={isSubmitted}
                                                    formState={formState}
                                                    isExternal={!!isExternal}
                                                    isStandAlone
                                                    shapeId={(formState?.fields?.trayShape?.value || formState?.fields?.trayShapeDimension?.shape.value) as ShapeId}
                                                    formSubmissionComponent={(
                                                        <FormSubmitter
                                                            artisanId={window.artisanPublicData?.id}
                                                            artisanSlug={artisanSlug || window.artisanPublicData?.slug}
                                                            isExternal={isExternal}
                                                            formState={formState}
                                                            onSelect={handleScrollToAnchor}
                                                            artisanProjectSource={artisanProjectId}
                                                        />
                                                    )}
                                                />
                                            </RenderDelayer>
                                        </div>
                                    </Fade>
                                ) : null;
                            })}
                        </>
                    </Container>
                </FormFieldsScrollWrapperStyle>
            </div>
        </>
    );
};

export default FormComposerChat;
